// components/shared/ErrorMessage.jsx
export function ErrorMessage({ message, onRetry }) {
  return (
    <div className="bg-red-600/10 border border-red-500/25 rounded-2xl p-5 backdrop-blur-sm">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 text-red-300">
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clipRule="evenodd"
            />
          </svg>
        </div>

        <div className="flex-1">
          <p className="text-red-200 text-sm font-medium">{message}</p>
          {onRetry && (
            <button
              onClick={onRetry}
              className="mt-3 inline-flex items-center rounded-xl border border-red-500/30 bg-red-600/10 px-3 py-1.5 text-xs font-semibold text-red-200 hover:bg-red-600/20"
            >
              Reintentar
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
